<template>
	<EventLayout :event="event" :subtitle="trans('events.schedule.title')">
		<template #actions>
			<PrimaryButton v-if="!event.schedule_file" :color="Color.Green" @click.stop="showModal('create-schedule-modal')">
				<i class="fa-solid fa-plus mr-2"/>
				{{ trans('general.create') }}
			</PrimaryButton>
			<SecondaryButton v-else :color="Color.Red" @click.stop="deleteSchedule">
				<i class="fa-solid fa-trash"/>
			</SecondaryButton>
		</template>
		<Modal id="create-schedule-modal">
			<template #title>{{ trans('events.schedule.add') }}</template>
			<LabeledObject>
				<template #label>{{ trans('events.schedule.file') }}</template>
				<input type="file" accept="image/jpeg,image/png" @change="newSchedule.file = loadFile($event)">
			</LabeledObject>
			<template #footer>
				<PrimaryButton :color="Color.Green" @click.stop="uploadSchedule">
					<i class="fa-solid fa-upload mr-2"/>
					{{ trans('general.upload_file') }}
				</PrimaryButton>
			</template>
		</Modal>
		<img v-if="event.schedule_file" class="w-full rounded-lg" :src="storage(event.schedule_file)" :alt="trans('events.schedule.title')">
		<Empty v-else/>
	</EventLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import {defineProps, type Ref, ref} from 'vue'
import Modal from '@/Components/UI/Modals/Modal.vue'
import EventLayout from '@/Layouts/EventLayout.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import {type Event as AArEIIEvent} from '@/Types/Events/Event'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {loadFile, showInfo, showModal, showSuccess, showValidationErrors, storage} from '@/Helpers/general'

interface Schedule {
	file:File|null,
}

const props = defineProps<{
	event:AArEIIEvent,
}>()

const working:Ref<boolean> = ref(false)
const event:Ref<AArEIIEvent> = ref(props.event)
const newSchedule:Ref<Schedule> = ref({
	file: null,
})

function uploadSchedule():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.updating'))
		const formData = new FormData
		formData.append('file', newSchedule.value.file ?? '')
		axios.post(route('events.schedule.upload', event.value.id), formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}).then(({data}) => {
			event.value.schedule_file = data
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}

function deleteSchedule():void{
	if(!working.value && confirm(trans('general.confirm_action'))){
		working.value = true
		showInfo(trans('general.deleting'))
		axios.delete(route('events.schedule.delete', event.value.id)).then(() => {
			event.value.schedule_file = null
			showSuccess(trans('general.deleted'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>